import React from 'react';
import { Trans } from 'react-i18next';

import { PromoInfoPage } from 'apps/promo/components/common/PromoInfoPage/PromoInfoPage';
import BasePageForNoAuth from 'apps/promo/components/utils/BasePageForNoAuth';
import { HELP } from 'apps/promo/constants/UrlConstants';
import { getLangCountryPrefix } from 'apps/promo/helpers/utils';
import { useApp, useLanguage } from 'apps/promo/hooks/selectors';

const NotFound = () => {
    const { country } = useApp();
    const { lang } = useLanguage();
    const helpLink = `${getLangCountryPrefix(lang, country)}${HELP}`;

    return (
        <PromoInfoPage
            animatedIconFail
            headerText={<Trans>ps.404.header.text</Trans>}
            secondaryText={<Trans>ps.404.error.description</Trans>}
            buttonRowType="link"
            buttonRowCaption={<Trans>ps.404.help</Trans>}
            buttonRowHref={helpLink}
        />
    );
};

export default BasePageForNoAuth(NotFound);
